import { Outlet } from 'react-router';
import { observer } from 'mobx-react-lite';
import { RedirectToLogin } from '@link/share/components';
import { useStore } from '@link/shibuya-sky/stores';

const PrivateRoute = () => {
  const { auth } = useStore();
  return auth.loggedIn ? <Outlet /> : <RedirectToLogin />;
};

const ObserverPrivateRoute = observer(PrivateRoute);

export default ObserverPrivateRoute;
